import { render, staticRenderFns } from "./CategoriesFilterMobile.vue?vue&type=template&id=06694c50&scoped=true&"
import script from "./CategoriesFilterMobile.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilterMobile.vue?vue&type=style&index=0&id=06694c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06694c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06694c50')) {
      api.createRecord('06694c50', component.options)
    } else {
      api.reload('06694c50', component.options)
    }
    module.hot.accept("./CategoriesFilterMobile.vue?vue&type=template&id=06694c50&scoped=true&", function () {
      api.rerender('06694c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/MobileFilters/CategoriesFilterMobile.vue"
export default component.exports